import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import {
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import SettingsItemTitle from './ItemTitle';

import { userHasFeature } from '../../../../helpers/Features';
import { getSetting } from '../../../../helpers/Settings';

const SettingsItemBoolean = ({
  settingKey,
  setting,
  disabled,
  handleChange,
}) => {
  const intl = useIntl();

  return (
    <>
      <Label for={`setting-${settingKey}`} className={classnames('switch', { disabled })} disabled={disabled}>
        <SettingsItemTitle setting={setting} />
        <div className="switch-control input-inner">
          <Input
            type="checkbox"
            name={`setting-${settingKey}`}
            id={`setting-${settingKey}`}
            value={true}
            checked={setting.value === true}
            disabled={disabled}
            onChange={handleChange}
          />
          <i />
        </div>
      </Label>
      {(
        settingKey === 'face_recognition' &&
        setting.value === true &&
        !getSetting('face_recognition')
      ) && (
        <div className="error">
          {intl.formatMessage({ defaultMessage: 'Please note that all photos will need to be processed for faces and this can take some time.' })}
        </div>
      )}
      {(
        settingKey === 'rekognition_videos' &&
        setting.value === true &&
        !getSetting('rekognition_videos') &&
        userHasFeature('ai-tagging-videos')
      ) && (
        <div className="error">
          {intl.formatMessage({ defaultMessage: 'Please note that all videos will need to be processed for tags and this can take some time.' })}
        </div>
      )}
      {(
        settingKey === 'search_document_content_documents' &&
        setting.value === true &&
        !getSetting('search_document_content_documents') &&
        userHasFeature('search-document-content')
      ) && (
        <div className="error">
          {intl.formatMessage({ defaultMessage: 'Your existing files will need to be processed before they become searchable. This can take some time depending on the number of files.' })}
        </div>
      )}
      {(
        settingKey === 'search_document_content_images' &&
        setting.value === true &&
        !getSetting('search_document_content_images') &&
        userHasFeature('search-document-content')
      ) && (
        <div className="error">
          {intl.formatMessage({ defaultMessage: 'Your existing images will need to be processed before they become searchable. This can take some time depending on the number of images.' })}
        </div>
      )}
      {(
        settingKey === 'search_document_content_videos' &&
        setting.value === true &&
        !getSetting('search_document_content_videos') &&
        userHasFeature('search-video-content')
      ) && (
        <div className="error">
          {intl.formatMessage({ defaultMessage: 'Your existing videos will need to be processed before they become searchable. This can take some time depending on the number of videos.' })}
        </div>
      )}
      {(
        settingKey === 'search_document_content_audio' &&
        setting.value === true &&
        !getSetting('search_document_content_audio') &&
        userHasFeature('search-video-content')
      ) && (
        <div className="error">
          {intl.formatMessage({ defaultMessage: 'Your existing audio files will need to be processed before they become searchable. This can take some time depending on the number of audio files.' })}
        </div>
      )}
      {(
        settingKey === 'download_with_reasons' &&
        setting.value === true
      ) && (
        <div className="error">
          {intl.formatMessage({ defaultMessage: 'Please reach out to us through your workspace chat to add download reasons.' })}
        </div>
      )}
      {settingKey === 'sidebar_hide_people' && (
        <p>
          {intl.formatMessage({
            defaultMessage: 'Hide the People menu item. Enable or disable Facial Recognition from the <link>AI tagging area in your workspace settings</link>.',
          }, {
            link: (msg) => (
              <Link to="/admin/settings/ai-tagging">
                {msg}
              </Link>
            ),
          })}
        </p>
      )}
    </>
  );
};

SettingsItemBoolean.propTypes = {
  settingKey: PropTypes.string.isRequired,
  setting: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
};

SettingsItemBoolean.defaultProps = {
  disabled: false,
};

export default SettingsItemBoolean;
